var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{
    'desktop': !_vm.isMobile,
    'mobile': _vm.isMobile,
    'home': _vm.isHome,
    'landing': _vm.isLanding,
    'homeout': !_vm.isHome && !_vm.isLanding,
  }},[(_vm.isMobile)?_c('navbar-mobile'):_c('navbar-desktop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }